// ── Welle A3: Sicherheit & Tipps — Typen und Beschriftungen (Server: server/lib/beitraege.js) ──
export type Vorlage = 'tipp' | 'lektion' | 'warnung' | 'checkliste' | 'ernstfall' | 'neu';
export type Thema = 'phishing' | 'passwoerter' | 'datenschutz' | 'ki';
export type Zielgruppe = 'alle' | 'klassenleitungen' | 'neu';
export type Aktion = 'ueberall_abmelden' | 'passwort_aendern' | 'meine_aktivitaet' | 'datenexport';
export type CheckPunkt = 'push' | 'ernstfall' | 'angemeldet_bleiben' | 'bildschirmsperre' | 'genehmigung' | 'datenexport';

export type Punkt = { text: string; kurz?: string };
export type Schritt = { titel: string; text?: string; aktion?: Aktion };
export type Baustein =
  | { typ: 'text'; titel?: string; text: string }
  | { typ: 'beispiel'; titel?: string; text: string; bild_id?: number }
  | { typ: 'bild'; bild_id: number; alt?: string }
  | { typ: 'hinweise'; titel?: string; punkte: Punkt[] }
  | { typ: 'hilft'; text: string }
  | { typ: 'checkliste'; titel?: string; punkte: Punkt[] }
  | { typ: 'schritte'; titel?: string; schritte: Schritt[] }
  | { typ: 'link'; titel: string; url: string };
export type BausteinTyp = Baustein['typ'];

export type BeitragKurz = {
  id: number; vorlage: Vorlage; thema: Thema | null; titel: string; teaser: string | null;
  serie_id: number | null; position: number | null; dauer_min: number | null; veroeffentlicht_am: string;
  gelesen: boolean; archiviert?: boolean; schritte: number; lernziele: string[];
};
export type Serie = { id: number; titel: string; beschreibung: string | null; gesamt: number; gelesen: number; naechste: { datum: string; titel: string } | null };
export type CheckWert = { am: string; quelle: string } | null;
export type CheckStand = {
  ernstfall: CheckWert; angemeldet_bleiben: CheckWert; bildschirmsperre: CheckWert; genehmigung: CheckWert; datenexport: CheckWert;
  erklaert: Partial<Record<CheckPunkt, number>>;
};
export type Uebersicht = {
  beitraege: BeitragKurz[]; serien: Serie[]; check: CheckStand; ungelesen: number;
  hinweis: { id: number; titel: string; teaser: string | null; vorlage: Vorlage } | null;
};
export type BeitragVoll = {
  id: number; vorlage: Vorlage; thema: Thema | null; titel: string; teaser: string | null; dauer_min: number | null;
  position: number | null; bausteine: Baustein[]; quelle: string | null; stand: string | null; veroeffentlicht_am: string;
  gelesen: boolean; serie: { titel: string; gesamt: number; naechste: { datum: string; titel: string } | null } | null;
};

export const VORLAGE_LABEL: Record<Vorlage, string> = { tipp: 'Tipp', lektion: 'Lektion', warnung: 'Warnung', checkliste: 'Checkliste', ernstfall: 'Ernstfall', neu: 'Neu in LehrerDesk' };
export const VORLAGE_ICON: Record<Vorlage, string> = { tipp: 'lightbulb', lektion: 'school', warnung: 'warning', checkliste: 'checklist', ernstfall: 'emergency_home', neu: 'auto_awesome' };
export const THEMA_LABEL: Record<Thema, string> = { phishing: 'Phishing', passwoerter: 'Passwörter', datenschutz: 'Datenschutz', ki: 'KI' };
export const THEMA_ICON: Record<Thema, string> = { phishing: 'phishing', passwoerter: 'key', datenschutz: 'shield_lock', ki: 'smart_toy' };
export const ZIELGRUPPE_LABEL: Record<Zielgruppe, string> = { alle: 'Alle Lehrkräfte', klassenleitungen: 'Klassenleitungen', neu: 'Neue Konten, erste 14 Tage' };
export const AKTION_LABEL: Record<Aktion, { label: string; icon: string }> = {
  ueberall_abmelden: { label: 'Überall abmelden', icon: 'logout' },
  passwort_aendern: { label: 'Passwort ändern', icon: 'key' },
  meine_aktivitaet: { label: 'Meine Aktivität', icon: 'history' },
  datenexport: { label: 'Datenexport', icon: 'download' },
};
export const BAUSTEIN_LABEL: Record<BausteinTyp, string> = {
  text: 'Text', beispiel: 'Beispiel mit Markierungen', bild: 'Bild', hinweise: 'Hinweise', hilft: 'So hilft dir LehrerDesk',
  checkliste: 'Checkliste', schritte: 'Schritte', link: 'Link',
};

/** SQLite-Zeit (UTC) → Date */
export const zeitAus = (s: string) => new Date(s.includes('T') ? s : s.replace(' ', 'T') + 'Z');
const zwei = (n: number) => String(n).padStart(2, '0');
/** TT.MM. bzw. TT.MM.JJJJ (Berliner Zeit) */
export function datumKurz(s: string, mitJahr = false) {
  const d = zeitAus(s);
  if (isNaN(d.getTime())) return '';
  const t = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' }).formatToParts(d);
  const g = (k: string) => t.find(p => p.type === k)?.value ?? '';
  return mitJahr ? `${g('day')}.${g('month')}.${g('year')}` : `${g('day')}.${g('month')}.`;
}
export const wochentag = (s: string) => zeitAus(s).toLocaleDateString('de-DE', { weekday: 'long', timeZone: 'Europe/Berlin' });
export { zwei };
